import React, { useState } from "react";
import { Box } from "@material-ui/core";
import {
  AssignAgentToRotationScheme,
  GetSuitableAgentsForRotationScheme,
} from "../../../../../Services";
import {
  CustomAsyncAutocomplete,
  CustomDialog,
  ReskinningInputs,
} from "../../../../../Components";
import { calculateCapacities } from "../../../AgentsView/AgentsDialogsView/capacityUtils";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "../styles";

function EditAgentDialog({
  isOpen,
  onClose,
  options: { editValues, schemaId, rotationAgents, getAllAgent },
}) {
  const styles = useStyles();
  const [selectedAgent, setSelectedAgent] = useState(editValues);
  const isDisabled = !(
    selectedAgent.agentId &&
    selectedAgent.monthlyCapacity &&
    selectedAgent.weeklyCapacity &&
    selectedAgent.dailyCapacity
  );
  const { translate } = useTranslate("NewAgentsRotationCriteria");

  const updateCapacity = (type, value) => {
    const capacities = calculateCapacities(type, value);
    setSelectedAgent({
      ...selectedAgent,
      ...capacities,
    });
  };

  return (
    <div>
      <CustomDialog
        paperClassName={styles.dialogWrapper}
        open={isOpen}
        onClose={() => {
          onClose(false);
        }}
        onConfirm={async () => {
          const filteredAgentIds = rotationAgents.filter(
            (agent) => agent.agentId !== editValues.agentId
          );
          const res = await AssignAgentToRotationScheme(
            schemaId,
            {
              agents: [...filteredAgentIds, selectedAgent],
            },
            false
          );
          if (!(res && res.status && res.status !== 200)) {
            getAllAgent();
          }

          onClose(false);
        }}
        content={
          <>
            <CustomAsyncAutocomplete
              labelValue={translate("agent-name")}
              selectedValues={selectedAgent}
              rootCustomClasses={styles.inputwrapper}
              onChange={(_e, value) => {
                if (value) {
                  //change agent but keep capicity data for other inputs
                  setSelectedAgent({
                    ...value,
                    monthlyCapacity: selectedAgent.monthlyCapacity,
                    weeklyCapacity: selectedAgent.weeklyCapacity,
                    dailyCapacity: selectedAgent.dailyCapacity,
                    agentLeadCapacityInRotation:
                      selectedAgent.agentLeadCapacityInRotation,
                  });
                }
              }}
              mapper={(data) => {
                return data.map((item) => item);
              }}
              queryKey={"search"}
              onFetchData={(filter) =>
                GetSuitableAgentsForRotationScheme(1, 1000, filter)
              }
              filter={{ search: null }}
              displayLabel={(option) => option?.agentName ?? ""}
              renderOption={(option) => option?.agentName}
              chipsLabel={(option) => {
                return option?.agentName;
              }}
              getOptionSelected={(option, value) =>
                option?.agentId === value?.agentId
              }
              //   refetchOnSearch
            />
            <Box display={"flex"} className={styles.wrapperContainer}>
              <div>
                <label className={styles.capacityLabel}>Lead Capacity</label>
                <p>Manage your team members here.</p>
              </div>
              <Box
                display={"flex"}
                flexDirection={"coulmn"}
                className={styles.capacityFieldsContainer}
              >
                <ReskinningInputs
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  value={selectedAgent.agentLeadCapacityInRotation}
                  onInputChanged={(e) => {
                    updateCapacity(
                      "agentLeadCapacityInRotation",
                      e.target.value
                    );
                  }}
                  inputPlaceholder={translate("over-all-capacity-placeholder")}
                  type="number"
                />
                <ReskinningInputs
                  value={selectedAgent.monthlyCapacity}
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  onInputChanged={(e) => {
                    updateCapacity("monthlyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("monthly-capacity-placeholder")}
                  type="number"
                />
                <ReskinningInputs
                  value={selectedAgent.weeklyCapacity}
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  type="number"
                  onInputChanged={(e) => {
                    updateCapacity("weeklyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("weekly-capacity-placeholder")}
                />
                <ReskinningInputs
                  value={selectedAgent.dailyCapacity}
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  type="number"
                  onInputChanged={(e) => {
                    updateCapacity("dailyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("daily-capacity-placeholder")}
                />
              </Box>
            </Box>
          </>
        }
        title={translate("edit-assign-agent ")}
        subtitle={translate("edit-assign-agent-subtitle")}
        cancelText={translate("cancel")}
        confirmText={translate("save")}
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default EditAgentDialog;
